import { render, staticRenderFns } from "./UserLevels.vue?vue&type=template&id=0ed230c0&scoped=true&"
import script from "./UserLevels.vue?vue&type=script&lang=js&"
export * from "./UserLevels.vue?vue&type=script&lang=js&"
import style0 from "./UserLevels.vue?vue&type=style&index=0&id=0ed230c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed230c0",
  null
  
)

export default component.exports